export enum ProjectStage {
  PRE_CONSTRUCTION = 'PRE_CONSTRUCTION',
  IN_CONSTRUCTION = 'IN_CONSTRUCTION',
  OPERATIONS = 'OPERATIONS'
}
